import { AfterViewInit, Component, EventEmitter, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { ApiService } from '../api.service';
import { Course } from '../types/course';

@Component({
	selector: 'app-generate-course-form-source',
	templateUrl: './generate-course-form-source.component.html',
	styleUrls: ['./generate-course-form-source.component.scss']
})

export class GenerateCourseFormSourceComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

	courseFormID = 0
	courseFormName = ''
	courseFormHeadingWords = 0
	courseFormCategory = 0
	newCourseID = 0
	
	generateBlankCourseLoading = false
	generateBlankCourseError = false
	generateBlankCourseSuccess = false
	
	generateBlankCourseSub = new Subscription()
	
	@Output() moveEvent = new EventEmitter<any>()
	
	constructor(private dataService: ApiService) { }

	ngOnInit(): void {
		this.courseFormID = this.dataService.getCourseFormID()
		this.courseFormName = this.dataService.getCourseFormName()
		this.courseFormCategory = this.dataService.getCourseFormCategory()
		// console.log(this.courseFormID)
		// console.log(this.courseFormName)
		// console.log(this.courseFormCategory)

		// console.log('form source init')
	}

	ngAfterViewInit(): void {
		// console.log('form source after view init')
	}

	ngOnChanges(): void {
		// console.log('form source changes')
	}
	
	ngOnDestroy(): void {
		this.generateBlankCourseSub?.unsubscribe()

		// console.log('form source destroy')
	}

	move(event: MouseEvent) {
		this.moveEvent.next(event)
	}

	generateBlankCourse() {
		this.courseFormID = this.dataService.getCourseFormID()
		this.courseFormName = this.dataService.getCourseFormName()
		this.courseFormCategory = +this.dataService.getCourseFormCategory()

		this.generateBlankCourseLoading = true
		this.generateBlankCourseError = false
		this.generateBlankCourseSuccess = false

		let newCourse = new Course()
		newCourse.name = this.courseFormName
		newCourse.hours = 0
		newCourse.category = this.courseFormCategory
		this.generateBlankCourseSub = this.dataService.generateBlankCourse(newCourse)
		.subscribe(
			id => {
				// console.log(id)

				this.generateBlankCourseLoading = false
				this.generateBlankCourseError = false
				this.generateBlankCourseSuccess = true

				this.dataService.clearCourseForm()
				this.newCourseID = id
			},
			_error => {
				// console.log(error)
				this.generateBlankCourseLoading = false
				this.generateBlankCourseError = true
				this.generateBlankCourseSuccess = false
			},
		)
	}
}